import axios from "axios";

const API = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";

export const getPendingApprovals = async () => {
  const res = await axios.get(`${API}/approvals/pending`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return res.data;
};

export const getDraftDetails = async (draftId: number) => {
  const res = await axios.get(`${API}/approvals/draft/${draftId}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return res.data;
};

export const submitDecision = async (
  approvalId: number,
  decision: "approved" | "rejected",
  note: string
) => {
  return axios.post(
    `${API}/approvals/decision`,
    { approval_id: approvalId, decision, note },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
};
